import { AuthContextShape } from "types";
import { setupContext } from "context/useCSContext";

export const Context = setupContext<AuthContextShape>("AuthContext");
